import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
    standalone: false
})
export class DeleteDialogComponent implements OnInit {

  heading;
  description;
  successMessage
  errorMessage
  palletType
  constructor(public dialogRef: MatDialogRef<DeleteDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.description = this.dataStore.description;
  }

  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick() {
    this.dialogRef.close({
      event: "ConfirmEvent",

    });
  }

}
